import { apiSlice } from "./apiSlice";

export const blogApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createBlog: builder.mutation({
      query: (blogData) => ({
        url: "/blogs/createBlog",
        method: "POST",
        body: blogData,
      }),
      invalidatesTags: ["Blog"],
    }),

    deleteBlog: builder.mutation({
      query: (id) => ({
        url: `/blogs/deleteBlog/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Blog"],
    }),

    updateBlog: builder.mutation({
      query: ({ blogData, id }) => ({
        url: `/blogs/updateBlog/${id}`,
        method: "PATCH",
        body: blogData,
      }),
      invalidatesTags: ["Blog"],
    }),

    getAllBlogs: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/blogs/getAllBlogs?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Blog"],
    }),

    getBlogById: builder.query({
      query: (id) => ({
        url: `/blogs/getBlogById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateBlogMutation,
  useUpdateBlogMutation,
  useDeleteBlogMutation,
  useGetAllBlogsQuery,
  useGetBlogByIdQuery,
} = blogApi;
